import createReducer from 'shared/utils/createReducer';
import { LOGOUT } from 'modules/auth/actions/logout';
import { STOP_CALL_RECONNECTION_FAILED } from 'modules/conference/actions/videoConsultation';
import { INITIATE_CONSULTATION } from 'modules/conference/actions/startConsultation';

import { STOP_CONSULTATION, STOP_CONSULTATION_LOCAL, HIDE_FINISHED_CONSULTATION } from '../actions/stopConsultation';

import {
  SET_CONSULTATION_ESTABLISHED,
  SET_RECONNECTION_STATUS,
  UNSET_RECONNECTION_STATUS,
} from '../actions/consultationLifecycle';

const defaultState = {
  consultationEstablishedAtLeastOneTime: false,
  reconnection: false,
  reconnectionTime: undefined,
};

export default createReducer(defaultState, {
  [SET_CONSULTATION_ESTABLISHED]: (state) => ({
    ...state,
    consultationEstablishedAtLeastOneTime: true,
  }),

  [SET_RECONNECTION_STATUS]: (state, { meta: { time } }) => ({
    ...state,
    reconnection: true,
    reconnectionTime: state.reconnectionTime || time,
  }),

  [STOP_CALL_RECONNECTION_FAILED]: (state) => ({
    ...state,
    consultationEstablishedAtLeastOneTime: false,
  }),

  [UNSET_RECONNECTION_STATUS]: (state) => ({
    ...state,
    reconnection: false,
    reconnectionTime: undefined,
  }),

  [HIDE_FINISHED_CONSULTATION]: () => defaultState,
  [STOP_CONSULTATION.success]: () => defaultState,
  [STOP_CONSULTATION_LOCAL]: () => defaultState,
  [INITIATE_CONSULTATION]: () => defaultState,

  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
